// extracted by mini-css-extract-plugin
module.exports = {"section_discover":"university_section_discover__1foGc","section_engage":"university_section_engage__F1fkC"};